import $ from 'jquery';

function openMenu() {
    let menuBtn = $('.js-menu-btn');
    menuBtn.hover(function (e) {
        menuBtn.toggleClass('open');
        $('header').next().toggleClass('open-menu');
        $('footer').toggleClass('open-menu');
    })
    $('.js-catalog-wrapper').on('click', function (e) {
        e.preventDefault();
    })
}

function openCart() {
    $('.header-top__basket').off('click').on('click',function () {
        console.log('open')
        $('body').addClass('open-menu');
        $(this).addClass('js-open-basket');
        $('#cart .modal-cart').addClass('open');
    })
}

function closeCart() {
    $('.js-close-btn').off('click').on('click', function () {
        const modal = $('.header-top__basket');
        if (modal.hasClass('js-open-basket')) {
            $('body').removeClass('open-menu');
            $('#cart .modal-cart').removeClass('open');
        }
    })
}


function removeEachProduct() {
    let products = $('.js-cart-products');
    products.each(function () {
        let remove = $(this).find('.js-button-remove');
        remove.addClass('test')
        let price = $(this).find('.js-cart-total').text();
        price = parseFloat(price)
        let clearPrice = parseInt(price);
        let penny = Math.ceil((price - clearPrice) * 100);
        let fullPrice = parseFloat(('' + clearPrice)  + '.' + ('' + penny));

        remove.click(function () {

            let cart = $('#cart-total');
            console.log(cart)

            let cartPenny = cart.find('sup').html();
            let cartClearPrice = parseInt(cart.html());
            let cartTotal = parseFloat(('' + cartClearPrice)  + '.' + ('' + cartPenny));

            let finalPrice = cartTotal - fullPrice;
            let finalClearPrice = Math.floor(finalPrice);
            let finalPenny = Math.ceil((finalPrice - finalClearPrice) * 100);
            finalPenny = finalPenny === 0?'':finalPenny;
            cart.html(finalClearPrice + '<sup>' + (finalPenny) +'</sup> <span class="currency">грн.</span>')
            removeEachProduct();
        })
    })
}

export { openMenu, removeEachProduct, openCart, closeCart };
